import { IsDefined, IsEmail, IsNotEmpty, IsString, Matches, MaxLength } from 'class-validator';

export class AccountRegisterRequest {
    @IsDefined()
    @IsString()
    @IsNotEmpty()
    @MaxLength(100)
    public dealerName: string;

    @IsDefined()
    @IsString()
    @IsNotEmpty()
    @MaxLength(100)
    public firstName: string;

    @IsDefined()
    @IsString()
    @IsNotEmpty()
    @MaxLength(100)
    public lastName: string;

    @IsDefined()
    @IsEmail()
    public email: string;

    @IsDefined()
    @Matches(/^\d{10,15}$/, { message: 'Phone must contain 10-15 digits' })
    public phone: string;

    constructor(data?: Partial<AccountRegisterRequest>) {
        this.dealerName = data?.dealerName;
        this.firstName = data?.firstName;
        this.lastName = data?.lastName;
        this.email = data?.email;
        this.phone = data?.phone;
    }
}
